import { createRouter, createWebHistory } from "vue-router";
import { routeAvailable } from "../util/integrations";
import { createPageVisitBeacon } from "../util/pageVisitBeacon";
import api from "../services/api";
const cookies = require("js-cookie");

// import store from '@/store';

const routes = [
	{
		path: "/",
		component: () => import(/* webpackChunkName: "main" */ "../views/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/Dashboard"),
			},
			{
				path: "/:catchAll(.*)",
				component: () => import(/* webpackChunkName: "404" */ "../views/404"),
			},
			{
				path: "/activiteiten/:catchAll(.*)",
				component: () => import(/* webpackChunkName: "404" */ "../views/404-activiteiten"),
			},
		],
	},
	{
		path: "/404",
		component: () => import(/* webpackChunkName: "main" */ "../views/__template_404"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/404"),
			},
		],
	},
	{
		path: "/bedrijfspagina",
		
		component: () => import(/* webpackChunkName: "main" */ "../views/companypages/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Overview"),
				
			},
			{
				path: "concept",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Concept"),
			},
		],
	},
	{
		path: "/openbare-pagina",
		component: () => import(/* webpackChunkName: "main" */ "../views/publicpage/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/publicpage/Overview"),
			},
			{
				path: "activiteiten",
				component: () => import(/* webpackChunkName: "main" */ "../views/publicpage/View"),
			},
		],
	},


	{
		path: "/formulier/:id",
		component: () => import(/* webpackChunkName: "main" */ "../views/single_intakeform/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/single_intakeform/View"),
			},

		],
	},
	{
		path: "/linkformulier/:id",
		component: () => import(/* webpackChunkName: "main" */ "../views/link_intakeform/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/single_intakeform/View"),
			},

		],
	},
	{
		path: "/intakeformulieren",
		meta: { requires: ["flexwell", "zoho"] },
		component: () => import(/* webpackChunkName: "main" */ "../views/intakeforms/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/intakeforms/Overview"),
			},
			{
				path: ":id",
				component: () => import(/* webpackChunkName: "main" */ "../views/intakeforms/View"),
			},
			{
				path: ":id/bewerken",
				component: () => import(/* webpackChunkName: "main" */ "../views/intakeforms/Edit"),
			},
		],
	},
	{
		path: "/contact",
		component: () => import(/* webpackChunkName: "main" */ "../views/contact/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/contact/Overview"),
			},

		],
	},
	{
		path: "/activiteiten",
		component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Overview"),
	},

	// De Specialistlink (ADR-0063). Geen sessie: het token in de URL is de
	// autorisatie, en hetzelfde Aanmeldingenoverzicht draait erop -- de rijvorm is
	// identiek, alleen de scope en de basis-URL van de acties verschillen.
	{
		path: "/link/:token",
		component: () => import(/* webpackChunkName: "main" */ "../views/activities/Registrations"),
		props: (route) => ({ token: route.params.token }),
	},

	{
		path: "/activiteiten/:id",
		component: () => import(/* webpackChunkName: "main" */ "../views/activities/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/activities/View"),
			},
			{
				path: "aanmeldingen",
				component: () => import(/* webpackChunkName: "main" */ "../views/activities/Registrations"),
			},
		],
	},
	{
		path: "/accountgegevens",
		component: () => import(/* webpackChunkName: "main" */ "../views/account/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/account/Overview"),
			},
		],
	},
	{
		path: "/afspraak-bevestigen",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/confirmation/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/confirmation/Overview"),
			},
		],
	},
	// De link uit de uitnodigingsmail (ClickUp 86c47j3zm). Openbaar, in de
	// layout van het inloggen: zonder sessie stuurt hij door naar inloggen of
	// registreren, met een sessie naar de activiteit.
	{
		path: "/uitnodiging/:token",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/invite/Landing"),
			},
		],
	},
	{
		path: "/verbinden",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/connect/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/connect/Overview"),
			},
		],
	},

	// {
	// 	path: "/instellingen",
	// 	component: () => import(/* webpackChunkName: "main" */ "../views/settings/__template"),
	// 	children: [
	// 		{
	// 			path: "",
	// 			component: () => import(/* webpackChunkName: "main" */ "../views/settings/Overview"),
	// 		},
	// 	],
	// },
	{
		path: "/review",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/review/__template"),
		children: [
			{
				path: ":id",
				component: () => import("../views/review/View"),
			},
		],
	},

	{
		path: "/inloggen",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Login"),
			},
			{
				path: "otp",
				component: () => import("../views/auth/OTP"),
			},
		],
	},

	{
		path: "/wachtwoord-vergeten",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Resetpassword"),
			},
		],
	},

	{
		path: "/wachtwoord-wijzigen",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Newpassword"),
			},
		],
	},

	{
		path: "/registreren",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Register"),
			},
		],
	},

	{
		path: "/registratie-voltooien",
		component: () => import(/* webpackChunkName: "register confirm" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Registerconfirm"),
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

// A page whose integration is off in the config sends you to the dashboard.
router.beforeEach((to) => (routeAvailable(to) ? true : "/"));

// Bezochte pagina's voor het Systeemlogboek. Fire-and-forget: een gemist
// bezoek mag de navigatie nooit hinderen.
const recordVisit = createPageVisitBeacon({
	send: (body) => api.post("v1/page-visits", body).catch(() => {}),
	hasSession: () => !!cookies.get("fmw_refresh_token") || !!cookies.get("fmw_access_token"),
	hostname: () => location.hostname,
});
router.afterEach((to, from, failure) => {
	if (!failure) recordVisit(to.path);
});



export default router;
